// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.historyContainer_WfQ_F::-webkit-scrollbar {
  display: none;
}
.historyContainer_WfQ_F {
  position: absolute;
  top: 0;
  right: 0;
  width: 500px;
  height: 100vh;
  max-height: 75vh;
  overflow-y: scroll;
  background-color: var(--white-color);
  animation: scaleUp_JwH8a 300ms ease-out forwards;
  padding-bottom: 20px;

  z-index: 999;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
  width: 100%;
  height: 100%;
}
.bg_cx0M3 {
  background-color: var(--_00000020-background);
  position: fixed;
  height: 100vh;
  width: 100vw;
  left: 0;
  top: 0;
}
.headerHistory_zJELZ {
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  img {
    transform: rotate(90deg);
    width: 15px;
    height: 15px;
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    -o-transform: rotate(90deg);
    cursor: pointer;
  }

  p {
    margin: 0;
    font-weight: 500;
    font-size: 13px;
  }
  button {
    background-color: transparent;
    border: none;
    text-decoration: underline;
    cursor: pointer;
    font-weight: 600;
    font-size: 13px;
  }
}
.contentHistory_Lz4Da {
  height: fit-content;
  background-color: var(--white-color);
  .content_hCd59 {
    margin: 20px 0;
  }
  .docs_Q9G26 {
    color: var(--595959-color);
    margin: 5px 0;
  }
  .payAt_q1Uju {
    color: var(--595959-color);
  }
  .title_DV5nW {
    font-weight: 500;
  }
  .totalIVA_wOyYS {
    font-weight: 700;
  }
  .planType_NiP6h {
    font-weight: 600;
    font-size: 20px;
    strong {
      font-weight: 800;
    }
  }
  .txtTransparent_AATX_ {
    color: #00000054;
  }
  .price_pcIZI {
    font-weight: 500;
  }
  .priceTotal_eSI1R {
    font-weight: 700;
  }
}
.contentHistory_Lz4Da p {
  margin: 0;
}

.contentHistory_Lz4Da .plan_waTjl {
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    background-color: #ececec;
    border: none;
    border-radius: 20px;
    -webkit-border-radius: 20px;
    -moz-border-radius: 20px;
    -ms-border-radius: 20px;
    -o-border-radius: 20px;
    cursor: pointer;
    color: var(--_2-color);
    font-weight: bold;
    display: flex;
    align-items: center;
    padding: 2px 10px;
  }
  .btns_NQloT {
    display: flex;
    gap: 10px;
  }
  img {
    cursor: pointer;
  }
}

.contentHistory_Lz4Da .section_WPgQL {
  border-bottom: 1px solid #0e0e0e1c;
  padding: 10px 0;
}

.contentHistory_Lz4Da .section_WPgQL:last-of-type {
  border-bottom: 3px solid #0e0e0e1c;
  padding: 10px 0 25px 0;
}

.contentHistory_Lz4Da .section_WPgQL .row_WPy6R {
  display: flex;
  justify-content: space-between;
}

.scaleDown_gQiOs {
  animation: scaleDown_gQiOs 300ms ease-in forwards;
  -webkit-animation: scaleDown_gQiOs 300ms ease-in forwards;
}


.fadeOut_nCPCX {
  opacity: 0;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/SeeHistory/SeeHistory.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,gDAA0C;EAC1C,oBAAoB;;EAEpB,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;AACA;EACE,6CAA6C;EAC7C,eAAe;EACf,aAAa;EACb,YAAY;EACZ,OAAO;EACP,MAAM;AACR;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB;IACE,wBAAwB;IACxB,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,6BAA6B;IAC7B,4BAA4B;IAC5B,2BAA2B;IAC3B,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,6BAA6B;IAC7B,YAAY;IACZ,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;AACF;AACA;EACE,mBAAmB;EACnB,oCAAoC;EACpC;IACE,cAAc;EAChB;EACA;IACE,0BAA0B;IAC1B,aAAa;EACf;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf;MACE,gBAAgB;IAClB;EACF;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;;EAEnB;IACE,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;IACf,sBAAsB;IACtB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,SAAS;EACX;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,iDAA2C;EAC3C,yDAAmD;AACrD;;;AAGA;EACE,UAAU;AACZ","sourcesContent":[".historyContainer::-webkit-scrollbar {\n  display: none;\n}\n.historyContainer {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 500px;\n  height: 100vh;\n  max-height: 75vh;\n  overflow-y: scroll;\n  background-color: var(--white-color);\n  animation: scaleUp 300ms ease-out forwards;\n  padding-bottom: 20px;\n\n  z-index: 999;\n  border-radius: 10px;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  -ms-border-radius: 10px;\n  -o-border-radius: 10px;\n  width: 100%;\n  height: 100%;\n}\n.bg {\n  background-color: var(--_00000020-background);\n  position: fixed;\n  height: 100vh;\n  width: 100vw;\n  left: 0;\n  top: 0;\n}\n.headerHistory {\n  display: flex;\n  flex-direction: row;\n  margin-top: 10px;\n  img {\n    transform: rotate(90deg);\n    width: 15px;\n    height: 15px;\n    -webkit-transform: rotate(90deg);\n    -moz-transform: rotate(90deg);\n    -ms-transform: rotate(90deg);\n    -o-transform: rotate(90deg);\n    cursor: pointer;\n  }\n\n  p {\n    margin: 0;\n    font-weight: 500;\n    font-size: 13px;\n  }\n  button {\n    background-color: transparent;\n    border: none;\n    text-decoration: underline;\n    cursor: pointer;\n    font-weight: 600;\n    font-size: 13px;\n  }\n}\n.contentHistory {\n  height: fit-content;\n  background-color: var(--white-color);\n  .content {\n    margin: 20px 0;\n  }\n  .docs {\n    color: var(--595959-color);\n    margin: 5px 0;\n  }\n  .payAt {\n    color: var(--595959-color);\n  }\n  .title {\n    font-weight: 500;\n  }\n  .totalIVA {\n    font-weight: 700;\n  }\n  .planType {\n    font-weight: 600;\n    font-size: 20px;\n    strong {\n      font-weight: 800;\n    }\n  }\n  .txtTransparent {\n    color: #00000054;\n  }\n  .price {\n    font-weight: 500;\n  }\n  .priceTotal {\n    font-weight: 700;\n  }\n}\n.contentHistory p {\n  margin: 0;\n}\n\n.contentHistory .plan {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  button {\n    background-color: #ececec;\n    border: none;\n    border-radius: 20px;\n    -webkit-border-radius: 20px;\n    -moz-border-radius: 20px;\n    -ms-border-radius: 20px;\n    -o-border-radius: 20px;\n    cursor: pointer;\n    color: var(--_2-color);\n    font-weight: bold;\n    display: flex;\n    align-items: center;\n    padding: 2px 10px;\n  }\n  .btns {\n    display: flex;\n    gap: 10px;\n  }\n  img {\n    cursor: pointer;\n  }\n}\n\n.contentHistory .section {\n  border-bottom: 1px solid #0e0e0e1c;\n  padding: 10px 0;\n}\n\n.contentHistory .section:last-of-type {\n  border-bottom: 3px solid #0e0e0e1c;\n  padding: 10px 0 25px 0;\n}\n\n.contentHistory .section .row {\n  display: flex;\n  justify-content: space-between;\n}\n\n.scaleDown {\n  animation: scaleDown 300ms ease-in forwards;\n  -webkit-animation: scaleDown 300ms ease-in forwards;\n}\n\n\n.fadeOut {\n  opacity: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"historyContainer": `historyContainer_WfQ_F`,
	"scaleUp": `scaleUp_JwH8a`,
	"bg": `bg_cx0M3`,
	"headerHistory": `headerHistory_zJELZ`,
	"contentHistory": `contentHistory_Lz4Da`,
	"content": `content_hCd59`,
	"docs": `docs_Q9G26`,
	"payAt": `payAt_q1Uju`,
	"title": `title_DV5nW`,
	"totalIVA": `totalIVA_wOyYS`,
	"planType": `planType_NiP6h`,
	"txtTransparent": `txtTransparent_AATX_`,
	"price": `price_pcIZI`,
	"priceTotal": `priceTotal_eSI1R`,
	"plan": `plan_waTjl`,
	"btns": `btns_NQloT`,
	"section": `section_WPgQL`,
	"row": `row_WPy6R`,
	"scaleDown": `scaleDown_gQiOs`,
	"fadeOut": `fadeOut_nCPCX`
};
export default ___CSS_LOADER_EXPORT___;
